module.exports = __webpack_public_path__ + "img/cl.727c4361.svg";